import React from 'react';
import Image from 'next/image';

const BuildFutureFarmingImage = () => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-12 text-center">
                        <Image
                            src="/img/agriculture-industry/svg/agriculture.svg"
                            className="img-fluid w-full"
                            alt="agriculture industry"
                            title="agriculture industry"
                            height={187}
                            width={1380}
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default BuildFutureFarmingImage;
